import { NgTemplateOutlet } from '@angular/common';
import {
  Component,
  inject,
  input,
  Signal,
  signal,
  TemplateRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { LayoutService } from '@app/modules/main/services/layout.service';
import {
  NgbNav,
  NgbNavChangeEvent,
  NgbNavItem,
  NgbNavLink,
} from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

export interface NavTab {
  title: string;
  icon: string;
  route?: string;
  redirectRoute?: string;
  template?: Signal<TemplateRef<any>>;
}

@Component({
  selector: 'app-nav-tabset',
  imports: [
    NgbNav,
    NgbNavItem,
    NgbNavLink,
    RouterLinkActive,
    RouterLink,
    RouterOutlet,
    NgTemplateOutlet,
    TranslateModule,
  ],
  templateUrl: './nav-tabset.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './nav-tabset.component.scss',
})
export class NavTabsetComponent {
  public tabs = input<NavTab[]>([]);

  protected activeTab = signal<number>(0);

  protected layoutService = inject(LayoutService);

  protected onNavChange(event: NgbNavChangeEvent) {
    this.activeTab.set(event.nextId);
  }

  protected isRouteBased() {
    return this.tabs().some((tab) => !!tab.route);
  }
}
